import { render } from "./quran.vue?vue&type=template&id=968cbfba"
import script from "./quran.vue?vue&type=script&lang=js"
export * from "./quran.vue?vue&type=script&lang=js"
script.render = render

export default script